<template>
  <div
    id="w-node-_33df7b64-d3e3-9bb8-c9ea-7c0b79a8b3cc-5bbc1f5a"
    class="founded-property-strip"
    :class="{'is-empty': foundedProperties.length === 0}"
  >
    <div class="property-strip-heading">
      <img
        src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f3a_property%20icon.png"
        loading="lazy"
        alt="Zakladané nehnuteľnosti"
        class="property-strip-icon"
      />
      <div class="property-strip-copy">
        <div class="property-strip-title">Zakladané nehnuteľnosti</div>
        <div v-if="foundedProperties.length" class="property-strip-description">
          {{ foundedProperties.length }} {{ foundedPropertyCountLabel }} · hodnota spolu
          <strong>{{ totalFoundedValue | dotTheAmount }} EUR</strong>
        </div>
        <div v-else class="property-strip-description">
          Bez zabezpečenia sú LTV a ponuky bánk iba orientačné.
        </div>
      </div>
      <div class="property-status" :class="{'is-complete': foundedProperties.length}">
        {{ foundedProperties.length ? 'Zabezpečenie zadané' : 'Chýba zabezpečenie' }}
      </div>
    </div>

    <div class="property-strip-content">
      <div class="property-list" v-if="foundedProperties.length">
        <div
          class="property-summary p-relative"
          v-for="(property, key) in foundedProperties"
          :key="key"
        >
          <div class="closebtn-broker-app pointer" @click="remove(property.id)">
            <img class="nav-link-icon extrasmall white" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f24_icons8-close.svg"/>
          </div>
          <div class="closebtn-broker-app pointer edit" @click="finishProperty(property)">
            <img class="nav-link-icon extrasmall white" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/64cb50251cbbf5e263940bb6_edit%20icon%20simple.svg"/>
          </div>
          <div class="property-address">{{ getAddressModified(property) }}</div>
          <v-progress-circular
            v-if="property.loading"
            class="loading-spinner extrasmall"
            indeterminate
          ></v-progress-circular>
          <div class="property-value" v-else>{{ property.hodnota | dotTheAmount }} EUR</div>
        </div>
      </div>
      <div class="property-strip-action">
        <client-property-handler
          :rules="['priority']"
          :type="'zakladane_nehnutelnosti'"
          :title="foundedProperties.length ? '+ pridať ďalšiu NEHNUTEĽNOSŤ' : '+ pridať zakladanú NEHNUTEĽNOSŤ'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ClientPropertyHandler from "../../../../shared/PopupHandler/Popups/ClientProperty/ClientPropertyHandler";
import { mapGetters } from "vuex";
import propertyFilters from "../../../../../mixins/propertyFilters";

export default {
  name: "FoundedProperty",
  components: {ClientPropertyHandler},
  props: {
    mortgageId: Number,
  },
  computed: {
    ...mapGetters({
      propertiesGetter: "mortgageDetailState/getProperties",
    }),
    totalFoundedValue () {
      return this.foundedProperties.reduce((total, property) => total + Number(property.hodnota || 0), 0);
    },
    foundedPropertyCountLabel () {
      if (this.foundedProperties.length === 1) return "nehnuteľnosť";
      if (this.foundedProperties.length > 1 && this.foundedProperties.length < 5) return "nehnuteľnosti";
      return "nehnuteľností";
    },
  },
  mixins: [
    propertyFilters,
  ],
  watch: {
    propertiesGetter (newProperties) {
      const deepEqual = require("deep-equal");
      const newFoundedProperties = this.filterFoundedPropertiesById(newProperties);
      this.foundedPropertiesIds = newProperties.foundedPropertiesIds;
      if (!deepEqual(this.foundedProperties, newFoundedProperties, true)) {
        this.foundedProperties = newFoundedProperties;
      }
    },
  },
  created () {
    const propertiesObject = this.$store.getters["mortgageDetailState/getProperties"];
    this.foundedProperties = this.filterFoundedPropertiesById(propertiesObject);
    this.foundedPropertiesIds = propertiesObject.foundedPropertiesIds;
  },
  data: () => ({
    foundedProperties: [],
    properties: [],
  }),
  methods: {
    remove (idOfRemoved) {
      this.foundedPropertiesIds = this.foundedPropertiesIds.filter((id) => id !== idOfRemoved);
      const data = {
        propertyId: idOfRemoved,
        mortgageId: this.mortgageId,
        propertyLabel: "Zakladaná",
        propertyType: "foundedPropertiesIds",
        object: {
          zakladane_nehnutelnosti: this.foundedPropertiesIds,
        }
      };
      // console.log(data);
      this.$store.dispatch("mortgageDetailState/removeProperty", data);
    },
    finishProperty (pProperty) {
      let type = pProperty.child_type;
      if (type === "flat" && pProperty.typ_bytu === "v_rodinnom_dome") {
        type = "flatInHouse";
      } else if (type === "flat" && pProperty.typ_bytu === "v_bytovom_dome") {
        type = "flatInFlat";
      }
      this.propertyTypePicker(type, pProperty);
    },
    propertyTypePicker (type, propertyData = null) {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: {druh: "zakladane_nehnutelnosti", child_type: type},
        payload: propertyData,
        component: "ClientPropertyPopUp",
        rules: this.rules,
      });
    },
  },
};
</script>

<style scoped>
  .founded-property-strip {
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    padding: 18px 20px;
    border: 1px solid var(--app-border);
    border-radius: 14px;
    background: var(--app-surface);
    color: var(--app-text);
    box-shadow: var(--app-shadow);
  }

  .founded-property-strip.is-empty {
    border-color: rgba(215, 139, 28, 0.45);
    background: color-mix(in srgb, #d78b1c 8%, var(--app-surface));
  }

  .property-strip-heading {
    display: flex;
    min-width: 0;
    align-items: center;
    gap: 12px;
  }

  .property-strip-icon {
    width: 42px;
    height: 42px;
    flex: 0 0 42px;
    object-fit: contain;
  }

  .property-strip-copy {
    min-width: 0;
    flex: 1 1 auto;
  }

  .property-strip-title {
    color: var(--app-text);
    font-size: 15px;
    font-weight: 900;
  }

  .property-strip-description {
    margin-top: 2px;
    color: var(--app-text-muted);
    font-size: 12px;
  }

  .property-status {
    flex: 0 0 auto;
    padding: 7px 10px;
    border-radius: 999px;
    background: color-mix(in srgb, #d78b1c 16%, transparent);
    color: color-mix(in srgb, #d78b1c 76%, var(--app-text));
    font-size: 11px;
    font-weight: 800;
  }

  .property-status.is-complete {
    background: var(--app-success-soft);
    color: var(--app-success);
  }

  .property-strip-content {
    display: flex;
    min-width: 0;
    margin-top: 14px;
    align-items: stretch;
    gap: 12px;
  }

  .property-list {
    display: flex;
    min-width: 0;
    flex: 1 1 auto;
    flex-wrap: wrap;
    gap: 10px;
  }

  .property-summary {
    box-sizing: border-box;
    min-width: 210px;
    flex: 1 1 240px;
    padding: 13px 38px 13px 14px;
    border-radius: 12px;
    border: 1px solid var(--app-border);
    background: var(--app-surface-muted);
  }

  .property-address {
    overflow: hidden;
    color: var(--app-text);
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .property-value {
    margin-top: 4px;
    color: var(--app-text);
    font-weight: 900;
  }

  .property-strip-action {
    display: flex;
    min-width: 210px;
    flex: 0 1 280px;
    align-items: center;
    justify-content: center;
    padding: 10px 14px;
    border: 1px dashed color-mix(in srgb, var(--app-primary) 55%, transparent);
    border-radius: 12px;
    background: var(--app-primary-soft);
    text-align: center;
  }

  .property-strip-action ::v-deep .div-block-25,
  .property-strip-action ::v-deep .add-prijem-btn {
    margin: 0;
  }

  .closebtn-broker-app.pointer.edit{
    right:20px;
  }

  @media screen and (max-width: 767px) {
    .property-strip-heading,
    .property-strip-content {
      align-items: stretch;
      flex-direction: column;
    }

    .property-strip-icon {
      display: none;
    }

    .property-status {
      align-self: flex-start;
    }

    .property-strip-action,
    .property-summary {
      min-width: 0;
      width: 100%;
    }
  }
</style>
